/**
 * Workspace Service REST API
 *
 * Contact: ContactRequests@enverus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TabTransfer } from './tabTransfer';

export interface WorkspaceTransfer {
    name?: string;
    type?: WorkspaceTransfer.TypeEnum;
    userId?: string;
    imageUrl?: string;
    tabs?: Array<TabTransfer>;
}
export namespace WorkspaceTransfer {
    export const TypeEnum = {
        Personal: 'PERSONAL',
        Company: 'COMPANY'
    } as const;
    export type TypeEnum = (typeof TypeEnum)[keyof typeof TypeEnum];
}
